import React, { type ReactNode } from 'react'

import { navigate } from 'gatsby'
import { Auth0Provider, type AppState, type User } from '@auth0/auth0-react'
import { ThemeProvider } from '@wicadu/reina-pepiada'
import { type Languages } from '@wicadu/langscope'

import TranslatorProvider from '@HOCs/Providers/TranslatorProvider'
import colors from '@constants/theme-colors'

interface Props {
  children: ReactNode
}

interface PageProvidersProps extends Props {
  lang: Languages
}

function RootProviders({ children }: Props) {
  const onRedirectCallback = (appState?: AppState, user?: User) => {
    const lang = user?.['https://wicadu.com/lang'] || 'en'
    const country = appState?.country || 'global'

    navigate(`/${lang}/${country}`, { replace: true })
  }

  return (
    <Auth0Provider
      domain={process.env.AUTH0_DOMAIN}
      clientId={process.env.AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: `${process.env.ASSISTANT_LANDING_PAGE_HOST}/callback`,
        audience: process.env.API_GATEWAY_HOST,
      }}
      onRedirectCallback={onRedirectCallback}
    >
      <ThemeProvider mode='LIGHT' colors={colors}>
        {children}
      </ThemeProvider>
    </Auth0Provider>
  )
}

function PageProviders({ children, lang }: PageProvidersProps) {
  return (
    <TranslatorProvider lang={lang}>
      {children}
    </TranslatorProvider>
  )
}

export {
  PageProviders,
  RootProviders,
}
